import reloadTable from 'owa-mail-list-actions/lib/actions/data-loading/reloadTable';
import { TableView } from 'owa-mail-list-store';

/**
 * Reload table upon triage action failure
 * This is done to avoid infinite loading bug, which occurs if triage action fails
 * @param tableView the tableView param
 */
export default function onTriageActionFailed(tableView: TableView) {
    // VSO: 43747 - Can we add better checks to determine if we are in fileshub rather than check tableView is null
    if (!tableView) {
        return;
    }

    reloadTable(tableView);
}
